import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { SalarySheet, User } from "@lhd/types";
import { notification } from "antd";
// import { useSelector } from "react-redux";
// import { user } from "@lhd/features/users/selector";

export const useFetchSalary = (
  page: number,
  pageSize: number,
  filterParams: any,
) => {
  const companyId = getCompanyId();
  const { __BLOCK_API__, ...restFilterParams } = filterParams || {};
  // const auth = useSelector(user);

  return useQuery(
    [QUERY_NAME.ANNUAL_SUMMERIES, companyId, filterParams, page, pageSize],
    () =>
      axios({
        method: "get",
        url: SERVICES.ANNUAL_SUMMERIES,
        params: {
          ...restFilterParams,
          page: page,
          per_page: pageSize,
          company_id: companyId,
          // worker_id: auth?.workers?.[0]?.id,
        },
      }).then((res) => ({
        data: res.data as SalarySheet[],
        meta: {
          total: res.headers["x-total"] || 0,
          total_page: res.headers["x-total-pages"] || 0,
        },
      })),
    {
      staleTime: Infinity,
      enabled: !__BLOCK_API__,
    },
  );
};

export const useFetchOneSalary = (userId: any) => {
  return useQuery(
    [QUERY_NAME.USER, userId],
    () =>
      axios({
        method: "get",
        url: `${SERVICES.USERS}/${userId}`,
      }).then((res) => res.data as User),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!userId,
    },
  );
};

export const useDeleteMultipleSalary = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ listIds }: any) => {
      const formData = new FormData();
      listIds.forEach((id: any) => {
        formData.append(`delete_ids[]`, id);
      });
      formData.append("company_id", companyId);
      formData.append("login_company_id", companyId);
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.ANNUAL_SUMMERIES}/delete_multiple_store_salaries`,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.ANNUAL_SUMMERIES]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

export interface FetchSalaryFilterOptionsParams {
  salary_type: string;
  company_id: number | string;
  target_year?: number;
  field_names: string[];
  active_filters: Record<string, string[]>;
}

export const useFetchSalaryFilterOptions = (
  params: FetchSalaryFilterOptionsParams | null,
  enabled = true,
) => {
  return useQuery(
    [
      QUERY_NAME.ANNUAL_SUMMERIES,
      "filter_options",
      params?.company_id,
      params?.salary_type,
      params?.target_year,
      params?.field_names,
      params?.active_filters,
    ],
    async () => {
      if (!params) return null;

      const res = await axios({
        method: "post",
        url: `${SERVICES.ANNUAL_SUMMERIES}/filter_options`,
        data: {
          salary_type: params.salary_type,
          company_id: params.company_id,
          target_year: params.target_year,
          field_names: params.field_names,
          active_filters: params.active_filters,
        },
      });

      return res.data as {
        success: boolean;
        filter_options: Record<string, string[]>;
      };
    },
    {
      enabled: !!params && enabled,
      keepPreviousData: true,
      retry: false,
    },
  );
};
